'use strict';
/* Kalis/Claude - thousands separators in judge.me's review counts.
 *
 * judge.me prints raw digits: "(311704 anmeldelser)" and "Produktanmeldelser (311616)".
 * The counts come from their own templates (widget_summary_text, the subtab labels), which
 * have no number formatting, and CSS cannot reformat text - so it has to happen here.
 *
 * SCOPING MATTERS: this only touches the summary text and the subtab labels. Review
 * timestamps ("02/08/2026") also contain 4-digit runs and must not be touched, which is
 * why this never walks a whole review card.
 *
 * Idempotent: once grouped, the digits are separated by a non-breaking space, so they no
 * longer match a run of 4+ contiguous digits and a second pass does nothing.
 */

(function () {
  var SELECTORS = [
    '.jdgm-rev-widg__summary-text',
    '.jdgm-all-reviews__summary-text',
    '.jdgm-subtab__name',
    '.jdgm-histogram__percentage'
  ].join(', ');

  // Use the document language so each of the 8 storefronts groups the way its locale does.
  var locale = document.documentElement.lang || 'nb';
  var nf;
  try {
    nf = new Intl.NumberFormat(locale);
  } catch (e) {
    nf = new Intl.NumberFormat('nb');
  }

  function formatTextNode(node) {
    var before = node.nodeValue;
    if (!/\d{4}/.test(before)) return false;
    var after = before.replace(/\d{4,}/g, function (digits) {
      return nf.format(parseInt(digits, 10));
    });
    if (after === before) return false;
    node.nodeValue = after;
    return true;
  }

  function run() {
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      // direct text nodes plus one level down - never a whole card subtree
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) formatTextNode(node);
    });
  }

  var timer;
  function runSoon() {
    clearTimeout(timer);
    timer = setTimeout(run, 50);
  }

  ['jdgm.doneSetup', 'jdgm.doneSetupReviews', 'jdgm.doneAppendMoreReviews',
   'jdgm.doneAppendMoreReviewsInAllReviewsPage', 'jdgm.doneShowReviewsTab',
   'jdgm.filteredInAllReviewsPage', 'jdgm.openedTabInAllReviewsPage'].forEach(function (name) {
    document.addEventListener(name, runSoon, false);
  });

  // The widget loads lazily and code-split, so poll briefly as a safety net (20s).
  var tries = 0;
  var poll = setInterval(function () {
    run();
    if (++tries > 40) clearInterval(poll);
  }, 500);

  runSoon();
})();
